import type { IconName } from '@customerio/pluma-icons';
import { SEARCH_KIND_FILTERS, type ActiveCategory } from '../constants';
import { SEARCH_RESULT_HEADINGS } from './result-metadata';

export type CategoryFilterOption = {
  icon: IconName;
  label: string;
  value: ActiveCategory;
};

type GetAvailableCategoryFilterOptionsArgs = {
  canAccessForms: boolean;
  canAccessObjectTypes: boolean;
  isBuilder: boolean;
  isMasqWithoutAccess: boolean;
};

export function getAvailableCategoryFilterOptions({
  canAccessForms,
  canAccessObjectTypes,
  isBuilder,
  isMasqWithoutAccess,
}: GetAvailableCategoryFilterOptionsArgs): CategoryFilterOption[] {
  const options: CategoryFilterOption[] = [
    { icon: 'search', label: 'All', value: 'all' },
    { icon: 'segment', label: SEARCH_RESULT_HEADINGS.segment, value: SEARCH_KIND_FILTERS.segments },
  ];

  if (!isBuilder) {
    options.push(
      { icon: 'campaigns', label: SEARCH_RESULT_HEADINGS.campaign, value: SEARCH_KIND_FILTERS.campaigns },
      { icon: 'trigger-event', label: SEARCH_RESULT_HEADINGS.action, value: SEARCH_KIND_FILTERS.actions },
    );
  }

  options.push(
    { icon: 'layout', label: 'Templates', value: SEARCH_KIND_FILTERS.templates },
    { icon: 'newsletter', label: SEARCH_RESULT_HEADINGS.newsletter, value: SEARCH_KIND_FILTERS.newsletters },
    { icon: 'goal', label: SEARCH_RESULT_HEADINGS.goal, value: SEARCH_KIND_FILTERS.goals },
    {
      icon: 'transactional-api',
      label: SEARCH_RESULT_HEADINGS.transactional_message,
      value: SEARCH_KIND_FILTERS.transactional_messages,
    },
    {
      icon: 'in-app',
      label: SEARCH_RESULT_HEADINGS.anonymous_in_app,
      value: SEARCH_KIND_FILTERS.anonymous_in_apps,
    },
    { icon: 'navigation', label: SEARCH_RESULT_HEADINGS.navigation, value: SEARCH_KIND_FILTERS.navigation },
    { icon: 'integrations', label: 'Integrations', value: 'integrations' },
  );

  if (canAccessForms) {
    options.push({ icon: 'form', label: SEARCH_RESULT_HEADINGS.custom_form, value: 'forms' });
  }

  if (canAccessObjectTypes) {
    options.push({ icon: 'object', label: 'Objects', value: 'objects' });
  }

  if (!isMasqWithoutAccess) {
    options.push({ icon: 'person', label: SEARCH_RESULT_HEADINGS.customer, value: 'people' });
  }

  options.push({ icon: 'connect-file', label: SEARCH_RESULT_HEADINGS.docs, value: 'docs' });

  return options;
}
